import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';

import Title from '../../components/Title';
import CustomButton from '../../components/Button';
import CustomAlert from '../../components/Modale';
import ConfirmUnsubscribeModal from '../../components/Modale/ConfirmUnsubscribeModal';

import { getFullFrenchDate } from '../../utils/services/formats';
import { getUserLaunched } from "../../components/App/reducer";
import { getInvoicesLaunched } from "../../store/reducer";

const MyAccountSubscriptionPage = () => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [modaleOpen, setModaleOpen] = useState(false);

  const {user, userDynamo} = useSelector(state => ({
    user: state.getIn(['app', 'userData']),
    userDynamo: state.getIn(['app', 'userDynamo']),
  }));

  useEffect(() => {
    if (userDynamo.user.id) {
      dispatch(getUserLaunched({userId: userDynamo.user.id}));
      dispatch(getInvoicesLaunched({userId: userDynamo.user.id}));
    }
  }, [userDynamo.user.id]);

  if (!user) return null;

  const endDate = getFullFrenchDate(userDynamo?.contract?.endDate, 'fr-FR');

  const handleConfirmUnsubscribe = () => {
    setModaleOpen(true);  // Opens additional confirmation modal
    setOpenDialog(false);
  };

  const cancelModal = () => {
    setOpenDialog(false);
  };

  return (
    <Grid container direction="column" alignItems="center" justify="center">
      <Grid item>
        <Title title={`Bienvenue sur votre espace abonnement, ${user.firstName}`} color="secondary"/>
      </Grid>
      {user.subscriptionCancelled ? (
        <Grid item>
          <Box mt={2} display="flex" justifyContent="center">
            <Typography variant="h6" color="error">Votre abonnement a été annulé. Vous resterez membre
              jusqu'au {endDate}.</Typography>
          </Box>
        </Grid>
      ) : (
        <Grid item>
          <Box mt={2} display="flex" justifyContent="center">
            <Typography>Vous êtes membre jusqu'au {endDate}</Typography>
          </Box>
          <Box mt={2} display="flex" justifyContent="center">
            <CustomButton title="Se désinscrire" color="primary" variant="outlined"
                          handleClick={() => setOpenDialog(true)}/>
          </Box>
        </Grid>
      )}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>{"Confirmer la désinscription"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Vous êtes membre jusqu'au {endDate}. Si vous vous désinscrivez maintenant, vous resterez membre jusqu'à
            cette date. Voulez-vous confirmer votre désinscription ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelModal} color="primary">Annuler</Button>
          <Button onClick={handleConfirmUnsubscribe} color="primary" autoFocus>Confirmer</Button>
        </DialogActions>
      </Dialog>
      {modaleOpen && (
        <CustomAlert squareModale setOpenModale={() => setModaleOpen(false)} openFromParent={modaleOpen}
                     id="confirm unsubscribe">
          <ConfirmUnsubscribeModal userId={user.id}/>
          <Box className="closeButtonWrapper">
            <IconButton onClick={() => setModaleOpen(false)}>
              <FontAwesomeIcon icon={faArrowAltCircleLeft}/>
            </IconButton>
          </Box>
        </CustomAlert>
      )}
    </Grid>
  );
};

export default MyAccountSubscriptionPage;
